import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const defaultAdPerformancePeriod: FaireAdPerformancePeriodEntity = {
  token: "default",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "ACTIVE",
  startDate: "2026-06-01",
  endDate: "2026-06-30",
  impressions: 0,
  clicks: 0,
  adsSpendDollars: 0,
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
